import { render } from "./LoginForm.vue?vue&type=template&id=7c4a55f1&ts=true"
import script from "./LoginForm.vue?vue&type=script&lang=ts"
export * from "./LoginForm.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/angeloquijano/Git/IWARI/iwari-vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__